package com.essntl.features.address.data.supabase

import com.essntl.features.address.domain.model.GooglePlaceModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GooglePlaceDto(
    @SerialName("place_id")
    val placeId: String,
    val description: String,
    @SerialName("main_text")
    val mainText: String,
    @SerialName("secondary_text")
    val secondaryText: String,
) {
    fun toModel() = GooglePlaceModel(
        placeId = placeId,
        description = description,
        mainText = mainText,
        secondaryText = secondaryText,
    )
}
